import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommand, ActionCommandService } from '../../../../services/action-command.service';
import { MenuStateService } from '../../../../services/menu-state.service';
import { SangriaSuprimentoService } from '../../../../services/sangria-suprimento.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-supply',
  imports: [CommonModule, FormsModule, InputNumberModule, InputTextModule, TextareaModule, ButtonModule],
  templateUrl: './supply.component.html'
})
export class SupplyComponent implements OnInit, OnDestroy, ActionCommand {

  amount: number = 0;
  description: string = '';
  species: string = '';
  loading = false;

  constructor(
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService,
    @Inject(MenuStateService) private menuStateService: MenuStateService,
    @Inject(MessageService) private messageService: MessageService,
    private sangriaSuprimentoService: SangriaSuprimentoService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.performSupply(),
      getDescription: () => 'Realizar Suprimento'
    });

    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.goBack(),
      getDescription: () => 'Voltar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ESC');
  }

  performSupply(): void {
    if (this.amount <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'O valor do suprimento deve ser maior que zero.',
        life: 3000
      });
      return;
    }

    const pdvId = localStorage.getItem('pdvId');
    if (!pdvId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Nenhum PDV/turno aberto. Abra o turno antes de realizar suprimento.',
        life: 4000
      });
      return;
    }

    this.loading = true;
    this.sangriaSuprimentoService.createSupply({
      amount: this.amount,
      pdvId: parseInt(pdvId, 10),
      description: this.description?.trim() || null,
      species: this.species?.trim() || null
    }).subscribe({
      next: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso!',
          detail: `Suprimento de ${this.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} registrado com sucesso!`,
          life: 3000
        });
        this.amount = 0;
        this.description = '';
        this.species = '';
      },
      error: (err) => {
        this.loading = false;
        const detail = err?.error?.message ?? err?.message ?? 'Não foi possível registrar o suprimento. Tente novamente.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail,
          life: 5000
        });
      }
    });
  }

  goBack(): void {
    this.menuStateService.goBackToMainMenu();
  }

  getKey(): string {
    return 'F1';
  }

  execute(): void {
    this.performSupply();
  }

  getDescription(): string {
    return 'Realizar Suprimento';
  }
}
